import React, { useState } from "react";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";

import NotificationCard from "./NotificationCard";

const Notifications = ({
  notifications: allNotifications = [],
  handleDrawerClose,
}) => {
  const [hasMore, setHasMore] = useState(true);
  const [notifications, setNotifications] = useState(
    allNotifications.slice(0, 10)
  );

  const loadMore = async () => {
    if (notifications.length === allNotifications.length) {
      setHasMore(false);
    } else {
      setTimeout(() => {
        setNotifications((prev) => [
          ...prev,
          ...allNotifications.slice(prev.length, prev.length + 10),
        ]);
      });
    }
  };

  return (
    <InfiniteScroll
      dataLength={notifications.length}
      next={loadMore}
      hasMore={hasMore}
      scrollableTarget="scrollableContainer"
    >
      {notifications.map((item, i) => (
        <NotificationCard
          key={i}
          notificationData={item}
          handleDrawerClose={handleDrawerClose}
        />
      ))}
    </InfiniteScroll>
  );
};

export default Notifications;

Notifications.propTypes = {
  notifications: PropTypes.array,
  handleDrawerClose: PropTypes.func,
};
